import styled, { ThemeProvider } from "styled-components";
import { darkTheme } from "./utils/Themes";
import Navbar from "./components/Navbar";
import { BrowserRouter } from "react-router-dom";
import Hero from "./components/sections/Hero";
import { AnimatePresence } from "framer-motion";
import { LoaderThree } from "./components/ui/loader";
import { useState, lazy, Suspense, useEffect } from "react";
import SmoothScroll from "./components/utils/SmoothScroll";

const Skills = lazy(() => import("./components/sections/Skills"));
const Education = lazy(() => import("./components/sections/Education"));
const Achievements = lazy(() => import("./components/sections/Achievements"));
const Experience = lazy(() => import("./components/sections/Experience"));
const GeminiEffectSection = lazy(() => import("./components/sections/GeminiEffectSection"));
const Projects = lazy(() => import("./components/sections/Projects"));
const Contact = lazy(() => import("./components/sections/Contact"));
const Footer = lazy(() => import("./components/sections/Footer"));
const ProjectDetails = lazy(() => import("./components/Dialog/ProjectDetails"));

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  position: relative;
  min-height: 100vh;
`;

const Wrapper = styled.div`
  padding-bottom: 100px;
  background: linear-gradient(
      38.73deg,
      rgba(204, 0, 187, 0.15) 0%,
      rgba(201, 32, 184, 0) 50%
    ),
    linear-gradient(
      141.27deg,
      rgba(0, 70, 209, 0) 50%,
      rgba(0, 70, 209, 0.15) 100%
    );
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 30% 98%, 0 100%);
`;

function App() {
  const [openModal, setOpenModal] = useState({ state: false, project: null });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <ThemeProvider theme={darkTheme}>
        <LoaderThree />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <Body>
            <AnimatePresence>
              <div>
                <Hero />
                <Wrapper>
                  <Suspense fallback={<LoaderThree />}>
                    <Skills />
                    <Experience />
                  </Suspense>
                </Wrapper>
                <Suspense fallback={<LoaderThree />}>
                  <GeminiEffectSection />
                </Suspense>
                <Suspense fallback={<LoaderThree />}>
                  <Projects openModal={openModal} setOpenModal={setOpenModal} />
                </Suspense>
                <Wrapper>
                  <Suspense fallback={<LoaderThree />}>
                    <Education />
                    <Achievements />
                    <Contact />
                  </Suspense>
                </Wrapper>
                <Suspense fallback={null}>
                  <Footer />
                </Suspense>

                {openModal.state && (
                  <Suspense fallback={<LoaderThree />}>
                    <ProjectDetails
                      openModal={openModal}
                      setOpenModal={setOpenModal}
                    />
                  </Suspense>
                )}
              </div>
            </AnimatePresence>
          </Body>
        </SmoothScroll>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
